import { Icon } from "@iconify/react";
import {
    Box,
    Button,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import { Notes } from "./Notes";
import { useNavigate } from "react-router-dom";

export const Actions = () => {
    const navigate = useNavigate();
    return (
        <div>
            <Box padding={3}>
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={6} md={6}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                borderRadius: 3,
                            }}
                        >
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <Icon
                                            icon="uil:arrow-up"
                                            rotate={1}
                                            color="#2f72b3"
                                            width="25"
                                            height="25"
                                        />
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography
                                            fontWeight="bolder"
                                            fontSize={14}
                                        >
                                            Add Note
                                        </Typography>
                                    </ListItemText>

                                    <Notes />
                                </ListItem>
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={6} md={6}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                borderRadius: 3,
                            }}
                        >
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <Icon
                                            icon="uil:arrow-up"
                                            rotate={1}
                                            color="#2f72b3"
                                            width="25"
                                            height="25"
                                        />
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typography
                                            fontWeight="bolder"
                                            fontSize={14}
                                        >
                                            Ledger
                                        </Typography>
                                    </ListItemText>

                                    <Stack direction={"row"} spacing={2}>
                                        <Button
                                            onClick={() => {
                                                navigate(
                                                    "/my-tasks/ledger-view"
                                                );
                                            }}
                                            variant="contained"
                                        >
                                            Close
                                        </Button>
                                        <Button variant="outlined">0</Button>
                                    </Stack>
                                </ListItem>
                            </List>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};
